import { gql } from 'glimmer-apollo';

export const GAME_QUERY = gql`
  query ($slug: String) {
    game(slug: $slug) {
      id
      name
      slug
      title
      subTitle
      description
      image {
        url
      }
      releaseDate
      price
      purchaseLink
    }
  }
`;
